import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c2c79c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content full-height align-items-center d-flex" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", { href: $props.gtUrl }, [
        ($props.organizationName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.organizationName), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2)
    ])
  ]))
}